import { render, staticRenderFns } from "./industryHealthJournal.vue?vue&type=template&id=7c69f1fa"
import script from "./industryHealthJournal.vue?vue&type=script&lang=js"
export * from "./industryHealthJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c69f1fa')) {
      api.createRecord('7c69f1fa', component.options)
    } else {
      api.reload('7c69f1fa', component.options)
    }
    module.hot.accept("./industryHealthJournal.vue?vue&type=template&id=7c69f1fa", function () {
      api.rerender('7c69f1fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/ihj/industryHealthJournal.vue"
export default component.exports